export const manifest = {
  screens: {
    scr_j45wp2: { name: "Home", route: "/", position: {"x":160,"y":220} },
    scr_kael8z: { name: "Home – Selected work", route: "/#work", position: {"x":1560,"y":220} },
    scr_j6ccxt: { name: "Home – Writing", route: "/#writing", position: {"x":2960,"y":220} },
    scr_h0j1zy: { name: "Home – Playground", route: "/#playground", position: {"x":4360,"y":220} },
    scr_c3l199: { name: "Home – Contact", route: "/#contact", position: {"x":5760,"y":220} },
    scr_cj4l53: { name: "Home – Dark mode", route: "/", state: {"theme":"dark"}, position: {"x":7160,"y":220} },
    scr_xmvti8: { name: "Kordis – Password", route: "/work/kordis", state: {"unlocked":false}, position: {"x":160,"y":2200} },
    scr_2agdrj: { name: "Kordis case study", route: "/work/kordis", state: {"unlocked":true}, position: {"x":1560,"y":2200} },
    scr_g91qes: { name: "Clear Docs – Password", route: "/work/clear-docs", state: {"unlocked":false}, position: {"x":160,"y":4180} },
    scr_ai5rap: { name: "Clear Docs case study", route: "/work/clear-docs", state: {"unlocked":true}, position: {"x":1560,"y":4180} },
    scr_x2rp0w: { name: "Palacio de Hierro case study", route: "/work/palacio-de-hierro", position: {"x":160,"y":6160} },
    scr_68a70f: { name: "Vendoo case study", route: "/work/vendoo", position: {"x":1560,"y":6160} },
    scr_ym4r88: { name: "Botkeeper case study", route: "/work/botkeeper", position: {"x":2960,"y":6160} },
    scr_7mczs7: { name: "Cognitive Biases deck", route: "/playground/cognitive-biases", position: {"x":160,"y":8140} },
  },
  sections: {
    sec_eu7c0b: { name: "Home", x: 0, y: 0, width: 8520, height: 1180 },
    sec_6ffh2h: { name: "Case Studies – Kordis", x: 0, y: 1980, width: 2920, height: 1180 },
    sec_1rg1nd: { name: "Case Studies – Clear Docs", x: 0, y: 3960, width: 2920, height: 1180 },
    sec_uwa47x: { name: "Case Studies – Other", x: 0, y: 5940, width: 4320, height: 1180 },
    sec_q76gmw: { name: "Playground", x: 0, y: 7920, width: 1520, height: 1180 },
  },
  layers: [
    { kind: "section", id: "sec_eu7c0b", children: [
      { kind: "screen", id: "scr_j45wp2" },
      { kind: "screen", id: "scr_kael8z" },
      { kind: "screen", id: "scr_j6ccxt" },
      { kind: "screen", id: "scr_h0j1zy" },
      { kind: "screen", id: "scr_c3l199" },
      { kind: "screen", id: "scr_cj4l53" },
    ] },
    { kind: "section", id: "sec_6ffh2h", children: [
      { kind: "screen", id: "scr_xmvti8" },
      { kind: "screen", id: "scr_2agdrj" },
    ] },
    { kind: "section", id: "sec_1rg1nd", children: [
      { kind: "screen", id: "scr_g91qes" },
      { kind: "screen", id: "scr_ai5rap" },
    ] },
    { kind: "section", id: "sec_uwa47x", children: [
      { kind: "screen", id: "scr_x2rp0w" },
      { kind: "screen", id: "scr_68a70f" },
      { kind: "screen", id: "scr_ym4r88" },
    ] },
    { kind: "section", id: "sec_q76gmw", children: [
      { kind: "screen", id: "scr_7mczs7" },
    ] },
  ],
}
